import { Text } from "@mantine/core";
import React from "react";

function PhoneCountryCodeIcon() {
  return <Text size="sm">+63</Text>;
}

export default PhoneCountryCodeIcon;
